import { initialState, Actions, State, SHOW_SIDEBAR, HIDE_SIDEBAR } from '../types/sidebar'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SHOW_SIDEBAR:
      return {
        visibleSidebar: action.payload,
      }
    case HIDE_SIDEBAR:
      return {
        visibleSidebar: null,
      }
    default:
      return state
  }
}

export default reducers
